export const SET_CODES = 'SET_CODES'

export const setCodes = data => async dispatch => {
  dispatch({
    type: SET_CODES,
    payload: data
  })
}